import styled from "styled-components"; 


export const ContainerCardAtencionSinTurno = styled.div`
    min-width: 300px;
    min-height: 220px;
    border-radius: 8px;
    position: relative;
    box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
    display: flex;
    align-items: flex-end;
    @keyframes modalanimation {
        0% {
            opacity: 0;
            bottom: -100px;
        }
        100% { 
            opacity:1;
            bottom: 0px;
         }
    }
    animation: modalanimation 1.3s ease-in-out 1;
`;

export const TopCardAtencionSinTurno = styled.div`
    width: 100%;
    height: 64px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: var(--color-secondary-gradient);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 20px;
    color: var(--color-white);
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    span {
        width: 70%;
    }
`;

export const BodyCardAtencionSinTurno = styled.div`
    height: calc(100% - 64px);
    position: relative;
    width: 100%;
    .text {
        width: 100%;
        height: calc(100% - 40px);
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        gap: 15px;
        padding-left: 20px;
        .bold {
            font-weight: bold;
        }
    }
    button {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        color: var(--color-white);
        background-color: var(--color-broccoli);
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
`;

